<div [ngClass]="filter.inputClass" class="checkbox checkbox-info search-filter-segmentless search-filter-fields" *ngIf="section.open">
    <input id="{{filter.name}}" [(ngModel)]="filter.value" (change)="inputChangeEmitter.emit()" type="checkbox">
    <label for="{{filter.name}}">{{filter.label}}</label>
</div>